import { ReactComponent as IconChevronDown } from '@/assets/svgs/chevron-down.svg'
import { assetUrl } from '@/utils/asset-url'
import { ReactComponent as IconEclip } from '@/assets/svgs/eclip-large.svg'
import { ReactComponent as IconFolder } from '@/assets/svgs/folder-large.svg'
import { ReactComponent as IconFolderHide } from '@/assets/svgs/folders-hide.svg'
import { ReactComponent as IconFolderShow } from '@/assets/svgs/folders-show.svg'
import { ReactComponent as IconGridView } from '@/assets/svgs/grid-view.svg'
import { ReactComponent as IconSearch } from '@/assets/svgs/icon-search.svg'
import { ReactComponent as IconTableView } from '@/assets/svgs/table-view.svg'
import Dropdown from '@/components/Dropdown'
import InputSuffixIcon from '@/components/InputSuffixIcon'
import MultiSelectCheckbox from "@/components/MultiSelectCheckbox/index"
import Portal from '@/components/Portal/index.js'
import { sortByOptions, statusOptions } from '@/constants/index'
import useConfig from '@/hooks/use-config/index.js'
import useEclips from '@/hooks/use-eclips/index'
import useFolders from '@/hooks/use-folder/index'
import usePage from '@/hooks/use-page/index.js'
import usePaginating from '@/hooks/use-paginating/index.js'
import { useLocation } from '@/lib/router-dom'
import api from '@/services/api/eclips.js'
import rem from '@/utils/rem.js'
import { orderBy, uniqBy } from 'lodash'
import { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import EclipCard from './eclip-card.jsx'
import EclipDataTable from './eclip-data-table.jsx'
import FilterDropDown from './eclip-filter-dropdown.jsx'
import FolderCard from './folder-card.jsx'
import FolderDataTable from './folder-data-table.jsx'
import Search from '@/componentsDS/Search/index';
import { feature, features } from "@/utils/feature-verifier";


export default function Eclips() {
	const [isTableView, setIsTableView] = useState(false)

	const {
		items: folders,
		meta: foldersMeta,
		fetch: getAllFolders,
		update: moveToFolder,
		// currentItem,
		// get: getCurrentFolder,
		loading: folderLoading,
	} = useFolders()

	const {
		provideItems,
		consumeItems,
		fetch: getConfig,
		consumeSystems,
		provideSystems,
	} = useConfig()

	const pageLimit = 5;
	const { eclips, eclipsMeta, getAll: getAllEclips, loading: eclipLoading, setLoading } = useEclips()
	const { currentPath } = useLocation()
	const [refIdSearch, setRefIdSearch] = useState('')
	const [dataElementId, setDataElementId] = useState({})
	const [recipient, setRecipient] = useState({})
	const [badge, setBadge] = useState({})
	const [fromDate, setFromDate] = useState(null)
	const [endDate, setEndDate] = useState(null)
	const [caseOwner, setCaseOwner] = useState('')
	const [tags, setTags] = useState([])

	const { breadcrumbsItems, _setBreadcrumbsItems } = usePage({
		title: currentPath.includes('shared') ? 'Shared with me' : 'My Packages',
		breadcrumbs: [
			'Package Sharing',
			currentPath.includes('shared') ? 'Shared with me' : 'My Packages',
		],
	})
	const [showFolders, setShowFolders] = useState(true)

	const {
		itemsPerPage: itemsPerPageEclips,
		currentPage: currentEclipsPage,
		goToPrev: goToPrevEclips,
		goToNext: goToNextEclips,
		handleCurrnetInput: handleCurrnetInputEclips,
		pageLabel: pageLabelEclips,
		sortConfig: sortConfigEclips,
		setSortConfig: setSortConfigEclips,
	} = usePaginating(
		pageLimit,
		eclipsMeta?.total,
		eclipsMeta?.totalPages,
	)

	const {
		itemsPerPage: itemsPerPageFolders,
		currentPage: currentFoldersPage,
		goToPrev: goToPrevFolders,
		goToNext: goToNextFolders,
		handleCurrnetInput: handleCurrnetInputFolders,
		pageLabel: pageLabelFolders,
		sortConfig: sortConfigFolders,
		setSortConfig: setSortConfigFolders,
	} = usePaginating(
		pageLimit,
		foldersMeta?.total,
		foldersMeta?.totalPages,
	)

	const [receivingTypeOptions, setReceivingTypeOptions] = useState([
		{ id: "COPY", label: "Copy", $selected: false },
		{ id: "DIRECT", label: "Direct Consume", $selected: false}
	]);

	const handleEclipsClearFilter = () => {
		setRefIdSearch('')
		setDataElementId({})
		setRecipient({})
		setBadge({})
		setFromDate(null)
		setEndDate(null)
		setCaseOwner('')
		setTags(tags.map(tag => ({ ...tag, active: false })))
		setReceivingTypeOptions(receivingTypeOptions.map(option =>({...option,$selected: false})))
	}

	const enableClear =
		recipient?.id || dataElementId?.id || refIdSearch?.length > 0 || fromDate || endDate || caseOwner?.email?.length > 0 || badge?.label || tags?.some(tag => tag.active ) || receivingTypeOptions?.some(option => option.$selected)

	// Recipient
	const [recipients, setRecipients] = useState([])

	function sortArray(array) {
		return orderBy(array, [(option) => option?.name.toLowerCase(), ['asc']])
	}

	const toggleFoldersClick = () => {
		setShowFolders(!showFolders)
	}

	useEffect(() => {
		const consumeOptions = consumeSystems.map((item) => ({
			id: item.id,
			name: item.name,
		}))
		const provideOptions = provideSystems.map((item) => ({
			id: item.id,
			name: item.name,
		}))

		const combineOptions = [...consumeOptions, ...provideOptions]
		const updatedOptions = uniqBy(combineOptions, 'id')

		setRecipients(sortArray(updatedOptions))
	}, [consumeSystems, provideSystems])
	const type = currentPath.includes('shared') ? 'RECEIVE' : 'SEND'

	const tagFilter = tags?.filter(tag => tag?.active)?.map(tag => tag.id)?.join(',') || undefined;

	const init = () => {
		getAllFolders({
			type,
			sort_order: sortConfigFolders.direction ? 'ASC' : 'DESC',
			sort_by: sortConfigFolders.key,
			limit: itemsPerPageFolders,
			page: currentFoldersPage,
		})
		getAllEclips({
			type,
			sort_by: sortConfigEclips.key,
			sort_order: sortConfigEclips.direction ? 'ASC' : 'DESC',
			data_element_ids: dataElementId?.id || undefined,
			org_ids: recipient?.id || undefined,
			reference_number: refIdSearch || undefined,
			status: badge?.key || undefined,
			limit: itemsPerPageEclips,
			page: currentEclipsPage,
			from_date: fromDate ? fromDate.toISOString() : undefined,
			to_date: endDate ? endDate.toISOString() : undefined,
			send_owner: currentPath.includes('shared') ? undefined : caseOwner?.email || undefined,
			receive_owner: currentPath.includes('shared') ? caseOwner?.email || undefined : undefined,
			tag_ids: tagFilter,
			receivedTxnType: convertArrayToString(receivingTypeOptions) ?? null
		})
		setIsTableView(localStorage.getItem('isTableView') === 'true')
		// getConfig()
	}

	useEffect(() => {
		handleCurrnetInputEclips({
			target: {
				value: 1
			}
		})
		handleCurrnetInputFolders({
			target: {
				value: 1
			}
		})
	}, [currentPath])

	useEffect(() => {
		api.getTags().then((response) => {
			setTags(response.data?.data);
		});
	}, [])

	useEffect(init, [currentPath, sortConfigFolders, sortConfigEclips, dataElementId, recipient, refIdSearch, badge, currentFoldersPage,
		fromDate, endDate, caseOwner, tagFilter, currentEclipsPage, receivingTypeOptions])

	function convertArrayToString(array) {
		if (!Array.isArray(array)) {
			return null;
		}
		if (array.every((item) => item.$selected === true)) {
			return null;
		}
		return retrieveIdfromMessages(array).toString();
	}

	function retrieveIdfromMessages(array) {
		const tempArray = [];
		array.forEach((item) => {
			if (item.$selected) {
				tempArray.push(item.id);
			}
		});
		return tempArray;
	}


	return (
		<>
			<div className="eclip-landing__filter overview">
				<div hidden onClick={init} id="reload-eclips"></div>
				<div className="eclip-filter ">
					<div className="search-data-input">
						<div style={{width:"350px"}}>
							<Search
								value={refIdSearch}
								placeholder="Search by Reference ID"
								onChange={(e) => setRefIdSearch(e?.target.value)}
								onCancel={() => setRefIdSearch('')}
							/>
						</div>

						<Dropdown
							placeholder="Find by Data Element"
							value={dataElementId.name}
							filterVisible
							style={{ width: rem(190), zIndex: 1 }}
						>
							{(currentPath.includes("shared") ? consumeItems : provideItems)?.map((option, index) => {
								return (
									<Dropdown.Item key={index}
										id={option.name}
										onClick={() => {
											if (option.name === dataElementId.name) {
												setDataElementId({});
											} else {
												setDataElementId(option);
											}
										}}
									>
										{option.name}
									</Dropdown.Item>
								);
							})}
						</Dropdown>

						{currentPath.includes('shared') && (
							<div className="eclip__dropdown-filter">
								<MultiSelectCheckbox
									items={receivingTypeOptions}
									onChangeFunc={setReceivingTypeOptions}
									label="Receiving Type"
								/>
							</div>
						)}

						<Dropdown
							placeholder={
								currentPath?.includes("shared")
									? "Find by Sender"
									: "Find by Recipient"
							}
							value={recipient.name}
							filterVisible
							style={{ width: rem(190), zIndex: 1 }}
						>
							{recipients.map((option, index) => {
								return (
									<Dropdown.Item key={index}
										id={option.name}
										onClick={() => {
											if (option.name === recipient.name) {
												setRecipient({});
											} else {
												setRecipient(option);
											}
										}}
									>
										{option.name}
									</Dropdown.Item>
								);
							})}
						</Dropdown>

						<Dropdown
							placeholder="Status"
							value={badge.label}
							style={{ width: rem(130), zIndex: 1 }}
						>
							{statusOptions.map((option, index) => {
								return (
									<Dropdown.Item key={index}
										id={option.label}
										onClick={() => setBadge(option)}
									>
										{option.label}
									</Dropdown.Item>
								);
							})}
						</Dropdown>

						<FilterDropDown
							active={enableClear}
							fromDate={fromDate}
							endDate={endDate}
							setFromDate={setFromDate}
							setEndDate={setEndDate}
							caseOwner={caseOwner}
							setCaseOwner={setCaseOwner}
							tags={tags}
							setTags={setTags}
						/>

						{enableClear && (
							<div onClick={handleEclipsClearFilter} className="cone-filter-reset">Reset</div>
						)}
					</div>
					<div className="eclip-landing__view-switch">
						{!isTableView && (
							<div className="search-data-input__sort-by">
								<span className="sort-by">Sort By</span>

								<Dropdown
									placeholder="Sort By"
									value={
										sortByOptions.find(
											(option) =>
												option.direction ===
												sortConfigEclips.direction
										)?.name
									}
									style={{ width: rem(130), zIndex: 1 }}
								>
									{sortByOptions.map((option, index) => {
										return (
											<Dropdown.Item key={index}
												onClick={() => {
													setSortConfigEclips({
														direction: option.direction,
														key: option.key,
													});
													setSortConfigFolders({
														direction: option.direction,
														key: option.key,
													});
												}}
												id={option.key}
											>
												{option.name}
											</Dropdown.Item>
										);
									})}
								</Dropdown>
							</div>
						)}
						<div
							className={isTableView ? "active" : ""}
							onClick={() => {
								setIsTableView(true);
								localStorage.setItem("isTableView", "true");
							}}
						>
							<IconTableView />
						</div>
						<div
							className={isTableView ? "" : "active"}
							onClick={() => {
								setIsTableView(false);
								localStorage.setItem("isTableView", "false");
							}}
						>
							<IconGridView />
						</div>
					</div>
				</div>
			</div>

			<div>
				{isTableView ? (
					<div className="eclip-landing__data-table">
						<div className="eclip-landing__sub-heading">
							Folders ({foldersMeta?.total || 0})
						</div>
						<FolderDataTable
							items={folders}
							pageLimit={pageLimit}
							goToPrev={goToPrevFolders}
							goToNext={goToNextFolders}
							currentPage={currentFoldersPage}
							sortConfig={sortConfigFolders}
							setSortConfig={setSortConfigFolders}
							meta={foldersMeta}
							handleCurrnetInput={handleCurrnetInputFolders}
						/>
					</div>
				) : (
					<>
						<div className="eclip-landing__heading-group">
							<div className="eclip-landing__sub-heading">
								Folders ({foldersMeta?.total || 0})
							</div>
							<div className="eclip-landing__pagination">
								{showFolders && foldersMeta?.total ?
									<div className="data-table__table__footer__row">
										<div className="data-table__table__footer__row__left">

											<div className="data-table__table__meta">
												Showing {pageLabelFolders}{" "}
												of {foldersMeta?.total || 0}{" "}
												entries
											</div>

										</div>
										<div className="data-table__table__footer__row__right">
											<div className="data-table__table__pagination">
												<input
													className="data-table__table__pagination__page"
													type="number"
													value={currentFoldersPage}
													onChange={(e) =>
														handleCurrnetInputFolders(
															e
														)
													}
													min="1"
												/>
												<span className="data-table__table__pagination__page__meta">
													{" "}
													of{" "}
													{foldersMeta?.totalPages ||
														1}{" "}
													pages{" "}
												</span>
												<button
													className="data-table__table__pagination__prev"
													onClick={() =>
														goToPrevFolders()
													}
													disabled={
														currentFoldersPage ===
														1 ||
														!foldersMeta?.totalPages
													}
												>
													<IconChevronDown />
												</button>
												<button
													className="data-table__table__pagination__next"
													onClick={() =>
														goToNextFolders()
													}
													disabled={
														currentFoldersPage ===
														foldersMeta?.totalPages ||
														!foldersMeta?.totalPages
													}
												>
													<IconChevronDown />
												</button>
											</div>
										</div>
									</div>
									: <div></div>}
								<div
									className="folders-toggle-switch"
									onClick={toggleFoldersClick}
								>
									{showFolders ? (
										<div>
											Hide Folders <IconFolderHide />
										</div>
									) : (
										<div className="active">
											Show Folders <IconFolderShow />
										</div>
									)}
								</div>
							</div>
						</div>
						{showFolders ? (
							<div>
								{folders?.length > 0 ? (
									<div className="eclip-landing-folder--wrapper">
										{folders?.map((item, index) => {
											return (
												<FolderCard
													key={index}
													item={item}
													moveToFolder={(
														id,
														payload
													) => {
														moveToFolder(
															id,
															payload
														).then(init);
													}}
												/>
											);
										})}
									</div>
								) : (
									<div className="data-table__table__body">
										<div className="data-table__empty">
											<div className="data-table__empty__icon">
												<IconFolder />
												<span>
													Click{" "}
													<b>Create New Folders</b> to
													organize your Eclips easily.
												</span>
											</div>
										</div>
									</div>
								)}
							</div>
						) : (
							<div className="eclip-landing-folder--wrapper"></div>
						)}
					</>
				)}
				{isTableView ? (
					<div className="eclip-landing__data-table">
						<div className="eclip-landing__sub-heading">
							Packages ({eclipsMeta?.total || 0})
						</div>
						<EclipDataTable
							items={eclips}
							pageLimit={pageLimit}
							goToPrev={goToPrevEclips}
							goToNext={goToNextEclips}
							currentPage={currentEclipsPage}
							sortConfig={sortConfigEclips}
							setLoading={setLoading}
							setSortConfig={setSortConfigEclips}
							meta={eclipsMeta}
							handleCurrnetInput={handleCurrnetInputEclips}
						/>
					</div>
				) : (
					<>
						{" "}
						<div className="eclip-landing__heading-group">
							<div className="eclip-landing__sub-heading">
								Packages ({eclipsMeta?.total || 0})
							</div>
							<div className="eclip-landing__pagination">
								{eclipsMeta?.total ? (<div className="data-table__table__footer__row">
									<div className="data-table__table__footer__row__left">
										<div className="data-table__table__meta">
											Showing {pageLabelEclips} of{" "}
											{eclipsMeta?.total || 0} entries
										</div>
									</div>
									<div className="data-table__table__footer__row__right">
										<div className="data-table__table__pagination">
											<input
												className="data-table__table__pagination__page"
												type="number"
												value={currentEclipsPage}
												onChange={(e) =>
													handleCurrnetInputEclips(e)
												}
												min="1"
											/>
											<span className="data-table__table__pagination__page__meta">
												{" "}
												of {eclipsMeta?.totalPages ||
													1}{" "}
												pages{" "}
											</span>
											<button
												className="data-table__table__pagination__prev"
												onClick={() => goToPrevEclips()}
												disabled={
													currentEclipsPage === 1 ||
													!eclipsMeta?.totalPages
												}
											>
												<IconChevronDown />
											</button>
											<button
												className="data-table__table__pagination__next"
												onClick={() => goToNextEclips()}
												disabled={
													currentEclipsPage ===
													eclipsMeta?.totalPages ||
													!eclipsMeta?.totalPages
												}
											>
												<IconChevronDown />
											</button>
										</div>
									</div>
								</div>
								) : (<div></div>)}
							</div>
						</div>
						<div>
							{eclips?.length > 0 ? (
								<div className="eclip-landing-package--wrapper">
									{eclips?.map((item, index) => {
										return (
											<EclipCard
												key={index}
												item={item}
											/>
										);
									})}
								</div>
							) : (
								<div className="data-table__table__body">
									<div className="data-table__empty">
										<div className="data-table__empty__icon">
											<IconEclip />
											You haven’t created any Packages,
										</div>
									</div>
								</div>
							)}
						</div>
					</>
				)}
			</div>
			{(folderLoading || eclipLoading) &&
				ReactDOM.createPortal(
					<div className="modal white">
						<div className="loading">
							<img src={assetUrl("/loading.gif")} />
						</div>
					</div>,
					document.body
				)}
		</>
	);
}
